import React from "react";
import Router from "./routes/Route";
import TNPCBChatbot from "./components/chart_bot/ChartBot";
function App() {
  return (
    // <Provider store={store}>
    //   <Router />
    //   <TNPCBChatbot />
    // </Provider>
    <div>
      <Router />
      <TNPCBChatbot />
    </div>
  );
}

export default App;
